import { type CSSProperties, type MouseEventHandler as ReactMouseEventHandler } from 'react';
import { Row } from '../Row';
import { Text } from '../Text';
import OversightAccountImage from '~/images/oversightAccountAvatar.svg';

interface IProps {
  onClick: ReactMouseEventHandler;
}

export const BackToOversightAccount = ({ onClick }: IProps) => {
  return (
    <Row width={'100%'} alignItems="center" margin={10} onClick={onClick}>
      <img
        src={OversightAccountImage}
        style={
          {
            width: 60,
            height: 60,
            resizeMode: 'contain',
          } as CSSProperties
        }
        alt="profile image"
      />
      <Text bold marginLeft={10}>
        Back to Oversight
      </Text>
    </Row>
  );
};
